import Image from 'next/legacy/image';
import Link from 'next/link';
import type { ArticleType } from 'service/article';

const ArticleCard = ({ article }: { article: ArticleType }) => {
  const { title, excerpt, type, category, date, thumbnail, href } = article;

  return (
    <Link
      href={href}
      className="block overflow-hidden rounded-2xl border border-pp-border-primary bg-white transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_24px_rgba(0,0,0,0.08)]"
    >
      {/* Article Image */}
      <div className="relative h-48 w-full overflow-hidden bg-pp-bg-secondary">
        <Image
          src={thumbnail}
          alt={title}
          layout="fill"
          objectFit="cover"
          className="transition-transform duration-300 hover:scale-105"
        />
      </div>
      {/* Article Content */}
      <div className="p-6">
        {/* Meta Information */}
        <div className="mb-3 flex items-center gap-3 text-xs text-pp-text-tertiary">
          <span className="font-semibold text-pp-green-primary">{type}</span>
          <span>•</span>
          <span>{date}</span>
        </div>

        {/* Title */}
        <h3 className="mb-3 line-clamp-2 text-xl font-bold leading-tight text-pp-text-primary">
          {title}
        </h3>

        {/* Excerpt */}
        <p className="line-clamp-3 text-sm leading-relaxed text-pp-text-secondary">
          {excerpt}
        </p>
      </div>
    </Link>
  );
};

export default ArticleCard;
